// This service now uses the unified image analysis service
// which tries multiple providers: Gemini → Hugging Face → Together AI
import { analyzeImage as unifiedAnalyzeImage, createEmptyAnalysis as unifiedCreateEmptyAnalysis } from "./unifiedImageService";

// Re-export for backward compatibility
export const analyzeImage = unifiedAnalyzeImage;
export const createEmptyAnalysis = unifiedCreateEmptyAnalysis;

// Helper function to list available Gemini models (for debugging)
export const listAvailableModels = async () => {
  try {
    const apiKey = import.meta.env.REACT_APP_GEMINI_API_KEY || import.meta.env.VITE_GEMINI_API_KEY;
    if (!apiKey) {
      return [];
    }
    const response = await fetch(
      `https://generativelanguage.googleapis.com/v1beta/models?key=${apiKey}`
    );
    const data = await response.json();
    return data.models || [];
  } catch (error) {
    console.error("Error listing models:", error);
    return [];
  }
};
